import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const NavigationBreadcrumbs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const pathSegments = location?.pathname?.split('/')?.filter(Boolean);

  const breadcrumbMap = {
    'authentication-hub': 'Authentication',
    'retail-user-dashboard': 'Retail Dashboard',
    'enterprise-client-dashboard': 'Enterprise Dashboard',
    'retail-partner-dashboard': 'Partner Dashboard',
    'super-administrator-dashboard': 'Admin Dashboard',
    'financial-data-aggregation': 'Financial Data'
  };

  const generateBreadcrumbs = () => {
    const breadcrumbs = [
      { label: 'Home', path: '/' }
    ];

    let currentPath = '';
    pathSegments?.forEach((segment) => {
      currentPath += `/${segment}`;
      const label = breadcrumbMap?.[segment] || segment?.split('-')?.map(word => 
        word?.charAt(0)?.toUpperCase() + word?.slice(1)
      )?.join(' ');
      
      breadcrumbs?.push({
        label,
        path: currentPath
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  const handleBreadcrumbClick = (path, index) => {
    if (index < breadcrumbs?.length - 1) {
      navigate(path);
    }
  };

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  return (
    <nav className="navigation-breadcrumbs" aria-label="Breadcrumb">
      {breadcrumbs?.map((crumb, index) => (
        <div key={crumb?.path} className="breadcrumb-item">
          {index < breadcrumbs?.length - 1 ? (
            <>
              <span
                className="breadcrumb-link"
                onClick={() => handleBreadcrumbClick(crumb?.path, index)}
              >
                {crumb?.label}
              </span>
              <Icon name="ChevronRight" size={14} className="breadcrumb-separator" />
            </>
          ) : (
            <span className="breadcrumb-current">{crumb?.label}</span>
          )}
        </div>
      ))}
    </nav>
  );
};

export default NavigationBreadcrumbs;